
import { IoIosRefresh } from "react-icons/io";
import { lazy } from "react";

const AtualizacoesWMS = lazy(() => import("./Atualizacao/AtualizacoesWMS").then((m) => ({ default: m.AtualizacoesWMS })));

const ModuleAtualizacao = {
  menuItem: {
    to: "/atualizacao",
    title: "Atualizações",
    icon: IoIosRefresh,
    id: 930,
    childrens: [
      {
        to: "/atualizacao",
        title: "Atualização",
        icon: IoIosRefresh,
        fullTitle: "Atualização",
        id: 76,
      },
    ],
  },

  routes: [
    {
      path: "/atualizacao",
      element: <AtualizacoesWMS />,
    },
  ],
};

export default ModuleAtualizacao;
